import { render, staticRenderFns } from "./WarehouseDelete.vue?vue&type=template&id=0849558e&"
import script from "./WarehouseDelete.vue?vue&type=script&lang=js&"
export * from "./WarehouseDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports